<template>
  <el-dialog
    :visible.sync="showDialog"
    width="900px"
    top="4vh"
    :close-on-click-modal="false"
    custom-class="whatsapp-templates-dialog"
    @close="onClose"
  >
    <div slot="title" class="wtd-header">
      <span class="wtd-header-icon"><i class="fa fa-whatsapp"></i></span>
      <div>
        <div class="wtd-header-title">Templates de Mensagem</div>
        <div class="wtd-header-subtitle">{{ parent && parent.formData ? parent.formData.nome : '' }}</div>
      </div>
    </div>

    <el-tabs v-model="activeTab" class="wtd-tabs">
      <!-- ABA: TEMPLATES EXISTENTES -->
      <el-tab-pane label="Templates Cadastrados" name="lista">
        <div class="templates-toolbar">
          <span class="templates-count" v-if="!loadingList">
            {{ templates.length }} template{{ templates.length === 1 ? '' : 's' }}
          </span>
          <div class="templates-toolbar-actions">
            <el-button size="small" icon="fa fa-refresh" :loading="loadingList" @click="carregarTemplates">
              Atualizar
            </el-button>
            <el-button size="small" type="primary" icon="fa fa-plus" @click="abrirNovo">
              Novo Template
            </el-button>
          </div>
        </div>

        <div v-loading="loadingList" class="templates-list">
          <div v-if="!loadingList && templates.length === 0 && !listError" class="templates-empty">
            <i class="fa fa-comments-o"></i>
            <p>Nenhum template encontrado nesta conta</p>
          </div>

          <div
            v-for="row in templates"
            :key="row.id || row.name"
            class="template-card"
            @click="visualizarTemplate(row)"
          >
            <div class="template-card-icon" :class="'is-' + (row.category || '').toLowerCase()">
              <i :class="categoriaIcone(row.category)"></i>
            </div>

            <div class="template-card-main">
              <div class="template-card-name">{{ row.name }}</div>
              <div class="template-card-meta">
                {{ categoriaLabel(row.category) }} · {{ idiomaLabel(row.language) }}
              </div>
            </div>

            <span class="template-status" :class="'is-' + (row.status || '').toLowerCase()">
              <i :class="statusIcone(row.status)"></i>
              {{ statusLabel(row.status) }}
            </span>

            <i class="fa fa-chevron-right template-card-chevron"></i>
          </div>
        </div>

        <div v-if="listError" class="templates-error">
          <i class="fa fa-exclamation-triangle"></i> {{ listError }}
        </div>
      </el-tab-pane>

      <!-- ABA: VISUALIZAR TEMPLATE -->
      <el-tab-pane label="Visualizar" name="visualizar" :disabled="!templateSelecionado">
        <div v-if="templateSelecionado" class="template-preview">
          <div class="template-preview-header">
            <div>
              <strong class="template-preview-name">{{ templateSelecionado.name }}</strong>
              <span class="template-status" :class="'is-' + (templateSelecionado.status || '').toLowerCase()" style="margin-left: 10px;">
                <i :class="statusIcone(templateSelecionado.status)"></i>
                {{ statusLabel(templateSelecionado.status) }}
              </span>
            </div>
            <span class="template-preview-meta">
              {{ categoriaLabel(templateSelecionado.category) }} · {{ idiomaLabel(templateSelecionado.language) }}
            </span>
          </div>

          <div v-if="templateSelecionado.status === 'REJECTED' && templateSelecionado.rejected_reason" class="templates-error">
            <i class="fa fa-exclamation-triangle"></i> Motivo da rejeição: {{ templateSelecionado.rejected_reason }}
          </div>

          <div class="preview-stage">
            <div class="whatsapp-bubble">
              <div
                v-for="(comp, idx) in templateSelecionado.components"
                :key="idx"
                class="whatsapp-bubble-component"
              >
                <div v-if="comp.type === 'HEADER'" class="whatsapp-bubble-header">
                  <template v-if="comp.format === 'TEXT'">{{ comp.text }}</template>
                  <template v-else>[Cabeçalho: {{ comp.format }}]</template>
                </div>
                <div v-else-if="comp.type === 'BODY'" class="whatsapp-bubble-body">{{ comp.text }}</div>
                <div v-else-if="comp.type === 'FOOTER'" class="whatsapp-bubble-footer">{{ comp.text }}</div>
                <div v-else-if="comp.type === 'BUTTONS'" class="whatsapp-bubble-buttons">
                  <div v-for="(btn, bidx) in comp.buttons" :key="bidx" class="whatsapp-bubble-button">
                    {{ btn.text }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <!-- ABA: NOVO TEMPLATE -->
      <el-tab-pane label="Novo Template" name="novo">
        <div v-loading="loadingSave" element-loading-text="Enviando para aprovação da Meta...">
          <div class="novo-template-layout">
            <div class="novo-template-form">
              <el-form label-position="top" :model="novoTemplate" ref="formNovo">
                <div class="row">
                  <div class="col-md-8">
                    <el-form-item>
                      <span slot="label">
                        Nome do Template
                        <el-tooltip effect="dark" placement="top" content="Apenas letras minúsculas, números e underscore. Ex: confirmacao_agendamento">
                          <a href="#"><i class="fa fa-question-circle"></i></a>
                        </el-tooltip>
                      </span>
                      <el-input
                        v-model="novoTemplate.name"
                        placeholder="ex: confirmacao_agendamento"
                        maxlength="512"
                        @input="normalizarNome"
                      />
                    </el-form-item>
                  </div>

                  <div class="col-md-4">
                    <el-form-item label="Idioma">
                      <el-select v-model="novoTemplate.language" style="width: 100%;">
                        <el-option label="Português (BR)" value="pt_BR" />
                        <el-option label="Inglês (US)" value="en_US" />
                        <el-option label="Espanhol" value="es" />
                      </el-select>
                    </el-form-item>
                  </div>

                  <div class="col-12">
                    <el-form-item label="Categoria">
                      <el-radio-group v-model="novoTemplate.category" class="category-radio-group">
                        <el-radio-button label="UTILITY">Utilidade</el-radio-button>
                        <el-radio-button label="MARKETING">Marketing</el-radio-button>
                        <el-radio-button label="AUTHENTICATION">Autenticação</el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                  </div>

                  <div class="col-12">
                    <el-form-item label="Cabeçalho (opcional)">
                      <el-input v-model="novoTemplate.header" placeholder="Texto do cabeçalho" maxlength="60" show-word-limit />
                    </el-form-item>
                  </div>

                  <div class="col-12">
                    <el-form-item>
                      <span slot="label">
                        Corpo da Mensagem
                        <el-tooltip effect="dark" placement="top">
                          <div slot="content" style="max-width: 320px;">
                            Use {1}, {2}, etc. para variáveis dinâmicas.<br>
                            Ex: Olá {1}, seu exame está agendado para {2}.
                          </div>
                          <a href="#"><i class="fa fa-question-circle"></i></a>
                        </el-tooltip>
                      </span>
                      <el-input
                        type="textarea"
                        :rows="5"
                        v-model="novoTemplate.body"
                        placeholder="Ex: Olá {1}, seu exame está agendado para {2}."
                        maxlength="1024"
                        show-word-limit
                      />
                    </el-form-item>
                  </div>

                  <div class="col-12">
                    <el-form-item label="Rodapé (opcional)">
                      <el-input v-model="novoTemplate.footer" placeholder="Texto do rodapé" maxlength="60" show-word-limit />
                    </el-form-item>
                  </div>
                </div>
              </el-form>

              <div v-if="saveError" class="templates-error">
                <i class="fa fa-exclamation-triangle"></i> {{ saveError }}
              </div>
            </div>

            <div class="novo-template-preview">
              <div class="template-preview-label">Pré-visualização</div>
              <div class="preview-stage preview-stage-sticky">
                <div class="whatsapp-bubble">
                  <div v-if="novoTemplate.header" class="whatsapp-bubble-header">{{ novoTemplate.header }}</div>
                  <div class="whatsapp-bubble-body">{{ novoTemplate.body || 'O corpo da mensagem aparecerá aqui...' }}</div>
                  <div v-if="novoTemplate.footer" class="whatsapp-bubble-footer">{{ novoTemplate.footer }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="novo-template-actions">
            <el-button @click="limparNovo">Limpar</el-button>
            <el-button type="primary" :loading="loadingSave" @click="enviarTemplate">
              <i class="fa fa-paper-plane"></i> Enviar para Aprovação da Meta
            </el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import Rest from 'common/rest';

const TEMPLATE_VAZIO = () => ({
  name: null,
  category: 'UTILITY',
  language: 'pt_BR',
  header: null,
  body: null,
  footer: null
});

export default {
  name: 'conta-whatsapp-templates',
  mixins: [Rest],
  props: {
    parent: { type: Object, default: null },
    showForm: { type: Boolean, default: false }
  },
  watch: {
    showForm(val) {
      this.showDialog = val;
      if (val) this.init();
    }
  },
  data() {
    return {
      showDialog: false,
      activeTab: 'lista',
      loadingList: false,
      loadingSave: false,
      listError: null,
      saveError: null,
      templates: [],
      templateSelecionado: null,
      novoTemplate: TEMPLATE_VAZIO()
    };
  },
  methods: {
    init() {
      this.activeTab = 'lista';
      this.templateSelecionado = null;
      this.listError = null;
      this.saveError = null;
      this.novoTemplate = TEMPLATE_VAZIO();
      this.carregarTemplates();
    },

    onClose() {
      this.$emit('update:showForm', false);
    },

    carregarTemplates() {
      if (!this.parent || !this.parent.formData) return;

      this.loadingList = true;
      this.listError = null;

      this.get('conta-whatsapp/templates/' + this.parent.formData.id).then(result => {
        result = result[0];
        this.loadingList = false;

        if (result.status == 200) {
          this.templates = result.data || [];
        } else {
          this.templates = [];
          this.listError = result.msg || 'Não foi possível carregar os templates desta conta.';
        }
      }).catch(() => {
        this.loadingList = false;
        this.listError = 'Não foi possível carregar os templates desta conta.';
      });
    },

    visualizarTemplate(row) {
      this.templateSelecionado = row;
      this.activeTab = 'visualizar';
    },

    abrirNovo() {
      this.novoTemplate = TEMPLATE_VAZIO();
      this.saveError = null;
      this.activeTab = 'novo';
    },

    limparNovo() {
      this.novoTemplate = TEMPLATE_VAZIO();
      this.saveError = null;
    },

    normalizarNome(val) {
      this.novoTemplate.name = (val || '')
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '');
    },

    categoriaLabel(cat) {
      var map = { MARKETING: 'Marketing', UTILITY: 'Utilidade', AUTHENTICATION: 'Autenticação' };
      return map[cat] || cat;
    },

    categoriaIcone(cat) {
      var map = {
        MARKETING: 'fa fa-bullhorn',
        UTILITY: 'fa fa-info-circle',
        AUTHENTICATION: 'fa fa-key'
      };
      return map[cat] || 'fa fa-file-text-o';
    },

    idiomaLabel(lang) {
      var map = { pt_BR: 'Português (BR)', en_US: 'Inglês (US)', es: 'Espanhol' };
      return map[lang] || lang;
    },

    statusLabel(status) {
      var map = {
        APPROVED: 'Aprovado',
        PENDING: 'Em análise',
        REJECTED: 'Rejeitado',
        PAUSED: 'Pausado',
        DISABLED: 'Desativado'
      };
      return map[status] || status;
    },

    statusIcone(status) {
      var map = {
        APPROVED: 'fa fa-check-circle',
        PENDING: 'fa fa-clock-o',
        REJECTED: 'fa fa-times-circle',
        PAUSED: 'fa fa-pause-circle',
        DISABLED: 'fa fa-ban'
      };
      return map[status] || 'fa fa-question-circle';
    },

    statusTagType(status) {
      var map = {
        APPROVED: 'success',
        PENDING: 'warning',
        REJECTED: 'danger',
        PAUSED: 'info',
        DISABLED: 'info'
      };
      return map[status] || 'info';
    },

    validarNovoTemplate() {
      if (!this.novoTemplate.name) {
        this.saveError = 'Informe o nome do template.';
        return false;
      }
      if (!this.novoTemplate.category) {
        this.saveError = 'Selecione a categoria do template.';
        return false;
      }
      if (!this.novoTemplate.body) {
        this.saveError = 'Informe o corpo da mensagem.';
        return false;
      }
      return true;
    },

    converterVariaveis(texto) {
      return (texto || '').replace(/\{(\d+)\}/g, '{{$1}}');
    },

    montarComponents() {
      var components = [];

      if (this.novoTemplate.header) {
        components.push({ type: 'HEADER', format: 'TEXT', text: this.novoTemplate.header });
      }

      components.push({ type: 'BODY', text: this.converterVariaveis(this.novoTemplate.body) });

      if (this.novoTemplate.footer) {
        components.push({ type: 'FOOTER', text: this.novoTemplate.footer });
      }

      return components;
    },

    enviarTemplate() {
      this.saveError = null;

      if (!this.validarNovoTemplate()) return;

      this.loadingSave = true;

      var payload = {
        id: this.parent.formData.id,
        name: this.novoTemplate.name,
        category: this.novoTemplate.category,
        language: this.novoTemplate.language,
        components: this.montarComponents()
      };

      this.post('conta-whatsapp/templates/criar', payload).then(result => {
        result = result[0];
        this.loadingSave = false;

        if (result.status == 200) {
          this.edMsg('Template enviado para aprovação da Meta com sucesso!');
          this.activeTab = 'lista';
          this.carregarTemplates();
        } else {
          this.saveError = result.msg || 'Não foi possível enviar o template para aprovação.';
        }
      }).catch(() => {
        this.loadingSave = false;
        this.saveError = 'Não foi possível enviar o template para aprovação.';
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// Header
.wtd-header {
  display: flex;
  align-items: center;
  gap: 14px;
}

.wtd-header-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #25d366;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.wtd-header-title {
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  line-height: 1.3;
}

.wtd-header-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.3;
}

.wtd-tabs {
  margin-top: 4px;
}

// Toolbar da lista
.templates-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.templates-count {
  font-size: 13px;
  color: #909399;
}

.templates-toolbar-actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

// Lista de templates (cards)
.templates-list {
  min-height: 120px;
}

.templates-empty {
  text-align: center;
  padding: 48px 0;
  color: #c0c4cc;

  i {
    font-size: 40px;
    margin-bottom: 10px;
    display: block;
  }

  p {
    margin: 0;
    font-size: 13px;
  }
}

.template-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 13px 14px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;

  &:hover {
    border-color: #d1e9ff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);

    .template-card-chevron {
      opacity: 1;
      transform: translateX(2px);
    }
  }
}

.template-card-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 15px;
  background: #f0f2f5;
  color: #909399;

  &.is-marketing {
    background: #fdf1e8;
    color: #e6a23c;
  }

  &.is-utility {
    background: #e8f4fd;
    color: #409eff;
  }

  &.is-authentication {
    background: #f0eefd;
    color: #7c6ee0;
  }
}

.template-card-main {
  flex: 1;
  min-width: 0;
}

.template-card-name {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.template-card-meta {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

.template-card-chevron {
  color: #c0c4cc;
  opacity: 0;
  transition: opacity 0.15s ease, transform 0.15s ease;
  flex-shrink: 0;
}

// Badge de status (compartilhado entre lista e visualização)
.template-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;

  &.is-approved {
    background: #eefaf0;
    color: #2f9e44;
  }

  &.is-pending {
    background: #fef8e8;
    color: #d4972a;
  }

  &.is-rejected {
    background: #fdeeee;
    color: #e05252;
  }

  &.is-paused,
  &.is-disabled {
    background: #f2f3f5;
    color: #909399;
  }
}

.templates-error {
  margin-top: 12px;
  padding: 10px 14px;
  background: #fef0f0;
  color: #f56c6c;
  border-radius: 4px;
  font-size: 13px;
}

// Visualização
.template-preview-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 16px;
}

.template-preview-name {
  font-size: 16px;
}

.template-preview-meta {
  color: #909399;
  font-size: 13px;
}

.template-preview-label {
  margin-bottom: 10px;
  font-size: 13px;
  color: #636363;
  font-weight: 600;
}

.preview-stage {
  background: #e5ded8;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  justify-content: center;
}

.preview-stage-sticky {
  position: sticky;
  top: 0;
}

// Novo template: layout de duas colunas
.novo-template-layout {
  display: flex;
  gap: 28px;
  align-items: flex-start;
}

.novo-template-form {
  flex: 1;
  min-width: 0;
}

.novo-template-preview {
  width: 280px;
  flex-shrink: 0;
}

.category-radio-group {
  width: 100%;

  ::v-deep .el-radio-button {
    width: 33.33%;

    .el-radio-button__inner {
      width: 100%;
    }
  }
}

.novo-template-actions {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

// Balão de WhatsApp (compartilhado entre visualização e preview de criação)
.whatsapp-bubble {
  max-width: 280px;
  width: 100%;
  background: #dcf8c6;
  border-radius: 8px;
  padding: 10px 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  line-height: 1.4;
  color: #303133;
}

.whatsapp-bubble-header {
  font-weight: 700;
  margin-bottom: 4px;
}

.whatsapp-bubble-body {
  white-space: pre-wrap;
  word-break: break-word;
}

.whatsapp-bubble-footer {
  margin-top: 6px;
  font-size: 12px;
  color: #667781;
}

.whatsapp-bubble-buttons {
  margin-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding-top: 6px;
}

.whatsapp-bubble-button {
  text-align: center;
  color: #00a5f4;
  padding: 6px 0;
  font-weight: 600;
}
</style>

<style lang="scss">
.whatsapp-templates-dialog {
  .el-dialog__header {
    padding: 20px 24px 16px;
    border-bottom: 1px solid #ebeef5;
  }

  .el-dialog__headerbtn {
    top: 22px;
  }

  .el-dialog__body {
    padding: 18px 24px 24px;
  }
}
</style>



// WEBPACK FOOTER //
// templates.vue?30971dec